import { useLingui } from "@lingui/react";
import FieldValuePair from "../FieldValuePair.tsx";
import type { SpecProps } from "./types.ts";

export const RegistrationNumber = ({ registrationNumber }: SpecProps<"registration_number">) => {
  const { i18n } = useLingui();

  if (registrationNumber == null || registrationNumber === "") {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.registration_number",
    message: "Registration number",
    comment: "Field for 'registration number' in ad specification",
  });
  return <FieldValuePair field={field} value={registrationNumber.toUpperCase()} />;
};
